(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["About"]) return;
  try {
    
  const swiper = new Swiper('.about-swiper', {

    // Optional parameters
    direction: 'vertical',
    loop: true,
    mousewheel: true,
    slidesPerView: 2,
    spaceBetween: 30
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-banner"]) return;
  try {
    

  const swiper = new Swiper('.swiper-home-banner-left', {

    // Optional parameters
    direction: 'horizontal',
    loop: true,
    autoplay: {
      delay: 3000
    },
    speed: 600,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    }

  });

  const swiperRight = new Swiper('.swiper-home-banner-right', {

    // Optional parameters
    direction: 'horizontal',
    loop: true,
    autoplay: {
      delay: 5000
    },
    speed: 600,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    }

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabButtons = document.querySelectorAll('.tab-button');
    const tabPanels = document.querySelectorAll('.tab-panel');

    tabButtons.forEach(button => {
      button.addEventListener('click', function() {
        const targetTab = this.getAttribute('data-tab');

// Remover clase active de todos los botones y paneles
        tabButtons.forEach(btn => btn.classList.remove('active'));
        tabPanels.forEach(panel => panel.classList.remove('active'));

// Agregar clase active al botón clickeado y su panel correspondiente
        this.classList.add('active');
        document.getElementById(targetTab).classList.add('active');
      });
    });
  });


  const swiper = new Swiper('.home-tabs-slider', {

    // Optional parameters
    direction: 'horizontal',
    loop: true,
    spaceBetween: 30,
    touchEventsTarget: 'container',
    touchStartPreventDefault: false,
    passiveListeners: true,
    threshold: 4,
    grabCursor: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: true
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
      400: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      640: {
        slidesPerView: 3,
        spaceBetween: 30
      }

    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-way"]) return;
  try {
    
  const swiper = new Swiper('.way-swiper', {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    spaceBetween: 10,
    mousewheel: true,
    touchEventsTarget: 'container',
    autoplay: {
      delay: 3000,
      disableOnInteraction: true
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 10

      }
    }
  });


  } catch(e) { console.error(e); }
})();
})();
